import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export const BidForm = ({
  minimumBid,
  bidAmount,
  setBidAmount,
  onSubmit,
  submitting,
  user,
}) => (
  <form onSubmit={onSubmit} data-testid="bid-form" className="mt-6 space-y-4">
    <div>
      <label className="label-eyebrow text-[#555]">Your bid (USD)</label>
      <Input
        data-testid="bid-amount-input"
        type="number"
        step="0.01"
        min={minimumBid}
        required
        value={bidAmount}
        onChange={(e) => setBidAmount(e.target.value)}
        className="mt-2 rounded-none border-b-2 border-l-0 border-r-0 border-t-0 border-[#E5E0D8] bg-transparent px-0 py-3 text-2xl font-mono-aam focus-visible:ring-0 focus-visible:border-[#1E3A8A]"
      />
    </div>
    <Button
      type="submit"
      data-testid="place-bid-btn"
      disabled={submitting}
      className="w-full rounded-none bg-[#1E3A8A] hover:bg-[#162a66] text-white py-6 h-auto label-eyebrow"
    >
      {submitting ? "Placing bid…" : `Place bid · $${parseFloat(bidAmount || minimumBid).toLocaleString()}`}
    </Button>
    {!user && (
      <p className="text-sm text-[#555]">
        <Link to="/login" className="text-[#1E3A8A] underline">Sign in</Link> to place a bid.
      </p>
    )}
  </form>
);
